export function siblingVariantUrl(base,variants,model,origin){
  const target=new URL(base,origin);
  const match=variants.find(v=>v.model===model);
  if(match)target.searchParams.set('variant',String(match.id));
  else target.searchParams.delete('variant');
  return target.pathname+target.search;
}
class MadamSiblingColors extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();
    this.scope=this.closest('.shopify-section')||this.parentElement;
    this.scope.addEventListener('change',()=>this.sync(),{signal:this.controller.signal});
    this.addEventListener('click',()=>this.sync(),{capture:true,signal:this.controller.signal});
    this.sync();
  }
  disconnectedCallback(){this.controller?.abort()}
  sync(){
    const picker=[...this.scope.querySelectorAll('variant-picker')].find(p=>p.dataset.productId===this.dataset.productId);
    if(!picker)return;
    const index=Number(picker.dataset.mcModelIndex);
    if(!Number.isInteger(index)||index<0)return;
    const model=picker.querySelector(`input[data-fieldset-index="${index}"]:checked`)?.value
      ||picker.querySelectorAll('select')[index]?.value;
    if(!model)return;
    for(const a of this.querySelectorAll('[data-sibling-url]')){
      try{a.href=siblingVariantUrl(a.dataset.siblingUrl,JSON.parse(a.dataset.siblingVariants),model,location.origin)}catch{}
    }
  }
}
if(!customElements.get('mc-sibling-colors'))customElements.define('mc-sibling-colors',MadamSiblingColors);
